module.exports = __webpack_public_path__ + "img/createDeleteCasino.812e7616.jpg";